import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { MapService } from 'app/services/map/map.service';
import * as ol from 'openlayers';

declare let $;//jquery


@Component({
  selector: 'app-legend-control',
  templateUrl: './legend-control.component.html',
  styleUrls: ['./legend-control.component.css']
})
export class LegendControlComponent implements OnInit, OnChanges {  
  @Output() closeLeftPanel = new EventEmitter<any>();

  @Input() selectedLegend: any;
  
  private showLeftPanel = false;
  private featureInfoResults = {};
  private resultsLeftPanel = {};
  private coordinates = [];
  private srs = "";
  private translateParams = {};
  private refcad = "";
  private subscription;
  private previewProperties;

  constructor(private mapService: MapService) {
    this.subscription = this.mapService
      .getFeatureInfoPanel()
      .subscribe(function (resultsLeftPanel) {
        this.resultsLeftPanel = resultsLeftPanel;
        setTimeout(() => $("#infoResultsHTML").html($(resultsLeftPanel)), 250);
      });
  }

  ngOnInit() {
  }

  ngOnChanges(changes) {
    try {
      if (
        typeof changes.results !== "undefined" &&
        typeof changes.results.currentValue !== "undefined"
      ) {
        this.extractPreview(changes.results.currentValue);
      }
    } catch (e) {
      console.warn(
        "Ups, hi ha hagut algun problema al ngOnChanges del legend-control.component.ts",
        e
      );
    }
  }

  private extractPreview(featureInfoResults) {
    this.featureInfoResults = featureInfoResults;
    try {
      if (featureInfoResults.features.length > 0) {
        let features = featureInfoResults.features; //Array
        this.coordinates = featureInfoResults.coordinates;
        let voronoiFeatureProperties = null;
        let parcelFeatureProperties = null;
        for (
          let featureIndex = 0;
          featureIndex < features.length;
          featureIndex++
        ) {
          let feature = features[featureIndex];
          if (feature["id"].indexOf("parcel") >= 0) {
            parcelFeatureProperties = feature["properties"];
          } else {
            voronoiFeatureProperties = feature["properties"];
          }
          if (parcelFeatureProperties && voronoiFeatureProperties) {
            break;
          }
        }
        this.previewProperties = voronoiFeatureProperties;
        if (parcelFeatureProperties != null) {
          this.refcad = parcelFeatureProperties.refcat;
        }
        this.srs = featureInfoResults.srs;
        this.translateParams = {
          coordenadaX: this.coordinates[0],
          coordenadaY: this.coordinates[1],
          refcad: this.refcad
        };
        this.showLeftPanel = true;
      }
    } catch (e) {
      console.warn(
        "Ups, hi ha hagut algun problema al extractPreview del legend-control.component.ts",
        e
      );
    }
  }

  private getUrbanisticInfo = function(){
    this.showLeftPanel = !this.showLeftPanel;
    setTimeout(() => $("#infoResultsHTML").html(this.resultsLeftPanel), 250);
  }

  private openStreetView () {
    let coordinates = this.mapService.getCoordinatesForInfo();
    let coordGeo = ol.proj.transform(coordinates, this.srs, "EPSG:4326");
    window.open(
      "http://maps.google.cat?layer=c&cbll=" +
        coordGeo[1] +
        "," +
        coordGeo[0],
      "Street View",
      "fullscreen=0, height=700, width=800"
    );
  };
  public closeLeftPanelHandler() {
    this.closeLeftPanel.emit("legend");
  }

  private printFeatureInfo() {
    /*let canvas = document.getElementsByClassName("ol-unselectable")[0];
    let img = canvas.toDataURL("image/png");
    let newcontentWindow = document.getElementById("fitxaImpressio")
      .contentWindow;
    let docu = newcontentWindow.document.open(); //si no s'obre no escrius enlloc.
    let info = $("#infoResultsHTML")[0].innerHTML;
    let mapa = '<img src="' + img + '"/>';
    let style1 = '<link href="fitxa_informacio.css" rel="stylesheet">';
    let style2 =
      '<link href="assets/css/opensans-font.css" rel="stylesheet">';
    docu.write(style2 + style1 + mapa + info);
    docu.close();
    setTimeout(function() {
      newcontentWindow.focus();
      newcontentWindow.print();
    }, 150);*/
  }
  // Sense referències, no es fa servir?
  private getInfoParams() {
    let infoParams = {};
    let indexParams = 0;
    for (let props in this.previewProperties) {
      infoParams[props] = this.previewProperties[props];
    }
    let tdList = $("#taulaInfo td");
    //let tdList = $(".tableColumn");
    for (let index = 0; index < tdList.length; index++) {
      let objData = $(tdList[index]).data();
      if (
        typeof objData !== "undefined" &&
        typeof objData["columnname"] !== "undefined"
      ) {
        let propertyName = objData["columnname"];
        if (
          typeof infoParams[propertyName] !== "undefined" &&
          (infoParams[propertyName] + "").indexOf(
            objData["columnvalue"]
          ) < 0
        ) {
          infoParams[propertyName] += "<br/>" + objData["columnvalue"];
        } else {
          infoParams[propertyName] = objData["columnvalue"];
        }
      }
    }
    infoParams["width"] = 18.48;
    infoParams["height"] = 17.63;
    infoParams["scale"] = "actual";
    infoParams["plantilla"] = "FITXA_A4V";
    infoParams["size"] = "A4";
    infoParams["orientacio"] = "V";
    return infoParams;
  }

  ngOnDestroy() {
    // unsubscribe to ensure no memory leaks
    this.subscription.unsubscribe();
  }

}



// WEBPACK FOOTER //
// /usr/nexus/jenkins/workspace/enmapa-geoportal-frontend/src/app/components/tools/legend-control/legend-control.component.ts